'use strict';
import {getOrganization} from '../../../app/model/reducers/state';
import {SCOPE_DESTROY} from '../../../config/constants/view-events';
import {LOADED, NO_DATA} from '../../../core-components/loading-icon/loading-states';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler, eventToObservable} from '../../../core-utilities/rx-utils';
import {logger} from '../logger';
import teamTypesCreateTemplate from './team-types-create.html';


module.exports = [
  '$scope',
  '$miscUtils',
  '$modal',
  '$popup',
  '$ngRedux',
  '$ionicViewSwitcher',
  'OrganizationDomain',
  TeamTypesManageController];

function TeamTypesManageController(
  $scope,
  $miscUtils,
  $modal,
  $popup,
  $ngRedux,
  $ionicViewSwitcher,
  OrganizationDomain,
) {
  const vm = $scope.teamTypesMgmt = this;

  vm.create = $miscUtils.blockPromise(create);
  vm.edit = $miscUtils.blockPromise(edit);
  vm.remove = $miscUtils.blockPromise(remove);

  $scope.$evalAsync(init);

  function init() {
    const organization$ = $ngRedux.state$
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY))
      .map(getOrganization)
      .distinctUntilChanged()
      .catch(epicErrorHandler(logger, 'organization$'));

    organization$
      .subscribe(organization => {
        $scope.$evalAsync(() => {
          vm.organization = organization;
        });
      });

    organization$
      .map(getId)
      .distinctUntilChanged()
      .switchMap(orgId => OrganizationDomain.$getTeamTypesList(orgId).$toObservable())
      .subscribe(teamTypes => {
        $scope.$evalAsync(() => {
          vm.loadingMode = teamTypes.$size() > 0 ? LOADED : NO_DATA;
          vm.teamTypes = teamTypes;
        });
      });
  }

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function create() {
    return edit(null);
  }

  function edit(type) {
    return $modal.show({
      template: teamTypesCreateTemplate,
      controller: 'TeamTypesCreateController',
      locals: {
        teamType: type,
        organization: getOrganization($ngRedux.getState()),
      },
    });
  }

  // TODO(i18n): convert to message codes
  function remove(type) {
    if (!type) {
      return Promise.resolve(null);
    } else {
      return $popup
        .confirm({
          title: 'Delete Team Type',
          /* eslint-disable-next-line max-len */
          template: '<div style="text-align: center;">Are you sure you want to delete<br/>' + type.toString() + '?<br/>This will delete all teams of this type.</div>',
        })
        .then(function (result) {
          if (result) {
            return type.$delete();
          }
        });
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/admin/TeamTypesManageController.js